import { EllipsesLoader } from '@/common/components/EllipsesLoader.tsx'
import { Card } from './Card'
import { ChildrenProp } from '@/common/types_and_interfaces.ts'

export type LoadingCardProps = {
  isLoading?: boolean
} & ChildrenProp

export default function LoadingCard({ isLoading, children }: LoadingCardProps) {
  return (
    <Card className="divide-y-0 p-4 flex flex-col items-center justify-center min-h-60 min-w-80 space-y-6">
      {isLoading && <EllipsesLoader size="md" />}
      <div className="text-gray-700 text-xl font-medium mt-3 flex flex-col items-center justify-center">
        {children}
      </div>
    </Card>

    // <div className="p-4 flex flex-col items-center justify-center min-h-52 min-w-80">
    //   {isLoading && <EllipsesLoader size="md" />}
    //   <span className="text-gray-800 text-xl font-medium mt-3">{prompt}</span>
    // </div>
  )
}
